import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export type MlifeVerificationRequest = {
  login: string;
  dob: string;
  mlifeNumber?: string;
  partner?: { name: string; tokenKey: string };
};

export type MlifeVerificationResponse = {
  activationKid: string;
};

export const mlifeVerificationRequest = async (requestBody: MlifeVerificationRequest) => {
  try {
    const result = await post('/guest/activate', {
      body: JSON.stringify(requestBody),
    });

    evaluateResponseErrorCode(result.response);

    return result.response as MlifeVerificationResponse;
  } catch (error) {
    throw getApiError(error);
  }
};
